<script>
    // Stores 
	import { 
		textSite 

	} from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import ListaImoveis from './../components/ListaImoveis.svelte'
	import PageHeader from './../components/PageHeader.svelte'

    // Code
    let titlePage = 'Favoritos';  	

	//Carrega bookmarks
	atria.loadBookmarks();

	let filtrosRent = {nt:atria.rent, pageSize:30, id:atria.bookmarks.Rent.join(',')};
	let filtrosSell = {nt:atria.sell, pageSize:30, id:atria.bookmarks.Sell.join(',')};
	let showFavoritos = true;

	if (atria.bookmarks.Rent.length === 0) {
		filtrosRent.id = 'SEM_FAVORITOS';
	}
	
	if (atria.bookmarks.Sell.length === 0) {
		filtrosSell.id = 'SEM_FAVORITOS';
	}

	if (filtrosRent.id === 'SEM_FAVORITOS' && filtrosSell.id === 'SEM_FAVORITOS') {
		showFavoritos = false;
	}

	function clearBookmarks() {
		atria.clearBookmarks();

		filtrosRent = {nt:atria.rent, pageSize:30, id:'SEM_FAVORITOS'};
		filtrosSell = {nt:atria.sell, pageSize:30, id:'SEM_FAVORITOS'};
		showFavoritos = false;
	}

	let buttons = [
		{
			name: 'Limpar Lista',
			icon: `<i class="far fa-ban"></i>`,
			href: 'javascript:void(0);',
			onClick: clearBookmarks
		},
		{
			name: 'Enviar para ' + $textSite,
			icon: `<i class="far fa-envelope"></i>`,
			href: `/favoritos-yara`,
		},
		{
			name: 'Enviar para Amigo',
			icon: `<i class="far fa-paper-plane"></i>`,
			href: '/favoritos-amigo',
		}
	];

	if (!showFavoritos) {
		buttons = [];
	}
	
</script>

<PageHeader title={titlePage} buttons={buttons}></PageHeader>

<div class="container">
{#if showFavoritos}
	<p>Confira sua lista de imóveis favoritos.</p>
	<section class="lista-imoveis">
		<ListaImoveis filters={filtrosRent} showPaginator={false} />
	</section>
	<section class="lista-imoveis">
		<ListaImoveis filters={filtrosSell} showPaginator={false} />
	</section>
{:else}
	 <p>Você não tem nenhum imóvel marcado como favorito.<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /></p>
{/if}
</div>